/*
 * GearFrost <gf-read-more> — collapses a block to a few lines with a See more / See less toggle.
 * The clamp is applied here (class `gf-description--enhanced`) so that without JS the full text is
 * shown (graceful degradation). The toggle button starts with the `hidden` attribute and is only
 * revealed when the content actually overflows the clamp, so short descriptions show no button.
 */
if (!customElements.get('gf-read-more')) {
  customElements.define(
    'gf-read-more',
    class GfReadMore extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('.gf-description__body');
        this.toggle = this.querySelector('.gf-description__toggle');
        if (!this.body || !this.toggle) return;

        // Turn on the CSS clamp now that JS can also expand it.
        this.classList.add('gf-description--enhanced');

        this.toggle.addEventListener('click', this.onToggle.bind(this));
        this._onResize = this.debounce(this.checkOverflow.bind(this), 150);
        window.addEventListener('resize', this._onResize);

        // Wait a frame so the clamp has been laid out before measuring.
        requestAnimationFrame(() => this.checkOverflow());
      }

      disconnectedCallback() {
        if (this._onResize) window.removeEventListener('resize', this._onResize);
      }

      checkOverflow() {
        if (this.classList.contains('is-expanded')) return;
        const overflows = this.body.scrollHeight > this.body.clientHeight + 2;
        this.toggle.hidden = !overflows;
      }

      onToggle() {
        const expanded = this.classList.toggle('is-expanded');
        this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (!expanded) {
          // Collapsing again — re-check whether the button is still needed.
          this.checkOverflow();
          var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
        }
      }

      debounce(fn, wait) {
        let t;
        return () => {
          clearTimeout(t);
          t = setTimeout(fn, wait);
        };
      }
    }
  );
}
